import React, { useContext, useEffect } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import classNames from "classnames";
import { getData, putData } from "../../../utils/api";
import {
  ExpertOrderType,
  IDS,
  OrderAssignType,
  OrderExpertStatus,
  RoleId,
  Select2Data,
} from "../../../utils/common";
import { logDOM } from "@testing-library/react";
import Spinner from "react-bootstrap/Spinner";
library.add(fas);

const DeliveredUpdateExpertOffCanvance = (props) => {
  const { postData, user } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});
  const GetOneDetails = async (id) => {
    try {
      const response = await getData(`/admin/orders/order/${id}`);

      if (response?.success) {
        setData(response?.data);
      } else {
        console.error("API failed:", response?.message);
      }
    } catch (err) {
      console.error("ERROR:", err);
    }
  };

  useEffect(() => {
    GetOneDetails(props.show);
  }, [props.show]);

  const {
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      assignments: [
        {
          expert_id: null,
          pickup_area_id: null,
        },
      ],
    },
  });
  const [dataAssign, setDataAssign] = useState({});
  const GetSingleData = async (id) => {
    const response = await getData(`/admin/orders/assign/experts/${id}`);
    if (response?.success) {
      reset(response?.data);
      setDataAssign(response?.data);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetSingleData(props.show);
    }
  }, [props.show]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "assignments",
  });
  const [loader, setLoader] = useState(false);
  const onSubmit = async (d) => {
    try {
      setLoader(true);
      const finalData = new FormData();
      finalData.append("no_of_expert", d?.no_of_expert);
      finalData.append(
        "order_assign_type_id",
        OrderAssignType.DeliveredMaterial,
      );
      const assignments = [];

      d.assignments?.forEach((val, index) => {
        const isLast = index === d.assignments.length - 1;

        const isFirst = index === 0;
        const role_id = isLast ? RoleId.Customer : RoleId.Expert;
        const expert_order_type_id = isFirst
          ? ExpertOrderType.PickupMaterial
          : isLast
            ? ExpertOrderType.DropMaterial
            : ExpertOrderType.TransferDelivery;
        const deliverd_user_id = isLast
          ? data?.user_id
          : d.assignments[index + 1]?.expert_id?.value;

        const pickup_user_id = isFirst
          ? data?.vendor_id
          : d.assignments[index - 1]?.expert_id?.value;

        assignments.push({
          id: val?.id,
          serial_no: index + 1,
          drop_area_id: val?.drop_area_id?.value ?? null,
          pickup_area_id: val?.pickup_area_id?.value ?? null,
          expert_id: val?.expert_id?.value ?? null,
          deliverd_user_id,
          pickup_user_id,
          role_id,
          expert_order_type_id,
        });
      });
      finalData.append("assignments", JSON.stringify(assignments));

      const response = await putData(
        `/admin/orders/assign/experts/${props?.show}`,
        finalData,
      );

      if (response?.success) {
        setLoader(false);
        await setShowModal({ code: response.code, message: response.message });
      } else {
        setLoader(false);
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const Select4Data = async (data, name, other = false) => {
    const result = data?.map((item) => ({
      value: item?.id,
      label: item?.name,
      name,
      data: item, // required for Expert_Areas access
    }));

    if (other) {
      result.push({
        value: "0",
        label: "Other",
        name,
      });
    }

    return result;
  };

  const [deliveryBoys, setDeliveryBoys] = useState([]);
  const [expertError, setExpertError] = useState("");
  const GetAllDeliveryBoys = async (value, location_type_id = 1) => {
    const lat = value?.data?.Area?.lat ?? data?.Vendor?.Shop_Detail?.lat ?? "";

    const long =
      value?.data?.Area?.long ?? data?.Vendor?.Shop_Detail?.long ?? "";

    const response = await getData(
      `/common/masters/order-expert?location_type_id=${location_type_id}&lat=${encodeURIComponent(
        String(lat).trim(),
      )}&long=${encodeURIComponent(String(long).trim())}`,
    );
    if (response?.success) {
      if (!response?.data?.length) {
        setDeliveryBoys([]);
        setExpertError("No expert available at this location");
        return;
      }

      setExpertError("");

      const expertList = await Select4Data(response.data, "expert_id");
      setDeliveryBoys(expertList);

      // const area = response?.data?.[0]?.Expert_Areas?.[0]?.Area;

      // if (area) {
      //   setValue("pickup_area_id", {
      //     value: area.id,
      //     name: "pickup_area_id",
      //     label: area.name,
      //   });
      // }
    }
  };

  useEffect(() => {
    GetAllDeliveryBoys();
  }, [props.show, data]);

  const Select3Data = async (data, name, other = false) => {
    const result = data?.map((item) => ({
      value: item?.Area?.id,
      label: item?.Area?.name,
      name: name,
      data: item,
    }));

    if (other) {
      result.push({ value: "0", label: "Other", name: name });
    }
    return result;
  };

  const [pickupAreas, setPickupArea] = useState([]);
  const GetAllPickupArea = async (expert_id) => {
    const response = await getData(
      `/common/masters/all-expert-area?location_type_id=${1}&expert_id=${expert_id}`,
    );
    if (response?.success) {
      setPickupArea(await Select3Data(response?.data, "pickup_area_id"));
    }
  };

  const [dropAreas, setDropArea] = useState([]);
  const GetAllDropArea = async (expert_id) => {
    const response = await getData(
      `/common/masters/all-expert-area?location_type_id=${2}&expert_id=${expert_id}`,
    );
    if (response?.success) {
      setDropArea(await Select3Data(response?.data, "drop_area_id"));
    }
  };

  // useEffect(() => {
  //   GetAllPickupArea();
  //   GetAllDropArea();
  // }, [props.show]);

  const noOfExpert = watch("no_of_expert");
  const assignments = watch("assignments") || [];

  useEffect(() => {
    const count = parseInt(noOfExpert || 0, 10);

    if (isNaN(count) || count < 0) return;

    if (count > fields.length) {
      for (let i = fields.length; i < count; i++) {
        append({
          expert_id: null,
          pickup_area_id: null,
          drop_area_id: null,
        });
      }
    } else if (count < fields.length) {
      for (let i = fields.length - 1; i >= count; i--) {
        remove(i);
      }
    }
  }, [noOfExpert]);

  // useEffect(() => {
  //   const setVendorArea = async () => {
  //     const count = Number(noOfExpert);

  //     if (!count || count <= 0) return;

  //     const response = await getData(
  //       `/common/masters/find-area?lat=${data?.Order?.Delivery_Address?.lat || ""}&long=${data?.Order?.Delivery_Address?.long || ""}`,
  //     );

  //     if (response?.success && response?.data) {
  //       const vendorArea = {
  //         value: response.data.id,
  //         label: response.data.name,
  //         name: "drop_area_id",
  //         data: response.data,
  //       };

  //       setValue(`assignments.${count - 1}.drop_area_id`, vendorArea);

  //       const area = response.data;
  //       const dropOption = {
  //         value: area.id,
  //         label: area.name,
  //         name: "drop_area_id",
  //         data: area,
  //       };
  //       setDropArea((prev) => {
  //         const exists = prev.some(
  //           (item) => Number(item.value) === Number(area.id),
  //         );

  //         if (exists) {
  //           return prev;
  //         }

  //         return [...prev, dropOption];
  //       });
  //     }
  //   };

  //   setVendorArea();
  // }, [noOfExpert, data, setValue]);

  // useEffect(() => {
  //   const setVendorArea = async () => {
  //     const count = Number(noOfExpert);

  //     if (!count || count <= 0) return;

  //     const response = await getData(
  //       `/common/masters/find-area?lat=${data?.Vendor?.Shop_Detail?.lat || ""}&long=${data?.Vendor?.Shop_Detail?.long || ""}`,
  //     );

  //     if (response?.success && response?.data) {
  //       const userArea = {
  //         value: response.data.id,
  //         label: response.data.name,
  //         name: "pickup_area_id",
  //         data: response.data,
  //       };

  //       setValue("assignments.0.pickup_area_id", userArea);
  //     }
  //   };

  //   setVendorArea();
  // }, [noOfExpert, data, setValue]);

  useEffect(() => {
    const setAreas = async () => {
      const count = Number(noOfExpert);

      if (!count || count <= 0) return;

      // Customer Address -> Pickup Area (First Expert)
      const pickupResponse = await getData(
        `/common/masters/find-area?lat=${data?.Vendor?.Shop_Detail?.lat || ""}&long=${data?.Vendor?.Shop_Detail?.long || ""}`,
      );

      if (pickupResponse?.success && pickupResponse?.data) {
        setValue(`assignments.0.pickup_area_id`, {
          value: pickupResponse.data.id,
          label: pickupResponse.data.name,
          name: "pickup_area_id",
          data: pickupResponse.data,
        });
      }

      // Vendor Shop -> Drop Area (Last Expert)
      const dropResponse = await getData(
        `/common/masters/find-area?lat=${data?.Order?.Delivery_Address?.lat || ""}&long=${data?.Order?.Delivery_Address?.long || ""}`,
      );

      if (dropResponse?.success && dropResponse?.data) {
        setValue(`assignments.${count - 1}.drop_area_id`, {
          value: dropResponse.data.id,
          label: dropResponse.data.name,
          name: "drop_area_id",
          data: dropResponse.data,
        });

        const area = dropResponse.data;
        const dropOption = {
          value: area.id,
          label: area.name,
          name: "drop_area_id",
          data: area,
        };
        setDropArea((prev) => {
          const exists = prev.some(
            (item) => Number(item.value) === Number(area.id),
          );

          if (exists) {
            return prev;
          }

          return [...prev, dropOption];
        });
      }
    };

    setAreas();
  }, [noOfExpert, data, setValue]);

  const getExpertOptions = (currentIndex) => {
    const selectedExpertIds = fields
      .map((_, index) => {
        if (index === currentIndex) return null;

        return watch(`assignments.${index}.expert_id`)?.value;
      })
      .filter(Boolean);

    return deliveryBoys.filter(
      (expert) => !selectedExpertIds.includes(expert.value),
    );
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Update Assign Experts
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="section-heading">Delivered Address</div>
          <div className="order-box">
            <span>
              <strong>Address : </strong>{" "}
              {data?.Order?.Delivery_Address?.street}{" "}
            </span>
            <div>
              <b>lat</b>: {data?.Order?.Delivery_Address?.lat}
            </div>
            <div>
              <b>long</b>: {data?.Order?.Delivery_Address?.long}
            </div>
            {/* <br></br>
            <span>
              <strong> Address : </strong>{" "}
              {
                data?.Order?.Material_Address?.Users_Address_Detail?.Pincode
                  ?.name
              }{" "}
              ,
            </span>
            <span>
              {data?.Order?.Material_Address?.Users_Address_Detail?.City?.name}{" "}
              ,
            </span>
            <span>
              {data?.Order?.Material_Address?.Users_Address_Detail?.State?.name}{" "}
              ,
            </span>
            <span>
              {
                data?.Order?.Material_Address?.Users_Address_Detail?.Country
                  ?.name
              }{" "}
              ,
            </span>
            <br></br> */}
            {/* <span><strong> Delivery Date : </strong> {data?.Order?.Material_Address?.delivery_date}{" "} </span><br></br>
                      <span><strong> Delivery Time : </strong>{data?.Order?.Material_Address?.delivery_time}{" "} </span><br></br> */}
          </div>

          <div>
            {" "}
            <div className="section-heading">Vendor Address</div>
            <div className="order-box">
              <span>
                <strong> Address : </strong>{" "}
                {data?.Vendor?.Shop_Detail?.address} ,
              </span>
              <div>
                <b>lat</b>: {data?.Vendor?.Shop_Detail?.lat}
              </div>
              <div>
                <b>long</b>: {data?.Vendor?.Shop_Detail?.long}
              </div>

              <br></br>
            </div>
          </div>
          {expertError && (
            <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
              {expertError}
            </div>
          )}
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Col md={6}>
              <div className="main-form-section mt-3">
                <Form.Group>
                  <div className="">
                    <Form.Label>No of Expert</Form.Label>
                  </div>
                  <InputGroup>
                    <Form.Control
                      type="text"
                      name="no_of_expert"
                      placeholder="No of Expert"
                      className={classNames("", {
                        "is-invalid": errors?.no_of_expert,
                      })}
                      onKeyDown={(e) => {
                        // Allow: Backspace, Delete, Tab, Escape, Enter, Arrow keys
                        if (
                          [
                            "Backspace",
                            "Delete",
                            "Tab",
                            "Escape",
                            "Enter",
                            "ArrowLeft",
                            "ArrowRight",
                            "ArrowUp",
                            "ArrowDown",
                          ].includes(e.key)
                        ) {
                          return;
                        }

                        // Allow only digits
                        if (!/^\d$/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      {...register("no_of_expert", {
                        required: "No of Expert is required",
                      })}
                    />
                  </InputGroup>
                  {errors.no_of_expert && (
                    <span className="text-danger">
                      {errors.no_of_expert.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            </Col>
            {fields.map((item, index) => (
              <Row key={item.id} className="border p-3 mb-3">
                <Col md={4}>
                  <Form.Label>Expert</Form.Label>

                  <Controller
                    control={control}
                    name={`assignments.${index}.expert_id`}
                    rules={{
                      required: "Select Expert",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={getExpertOptions(index)}
                        isDisabled={
                          index > 0 && !assignments[index - 1]?.drop_area_id
                        }
                        // options={deliveryBoys}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);

                          if (field.value?.value !== selectedOption?.value) {
                            if (index < fields.length - 1) {
                              setValue(
                                `assignments.${index}.drop_area_id`,
                                null,
                              );
                            }

                            for (
                              let nextIndex = index + 1;
                              nextIndex < fields.length;
                              nextIndex++
                            ) {
                              setValue(
                                `assignments.${nextIndex}.expert_id`,
                                null,
                              );
                              setValue(
                                `assignments.${nextIndex}.pickup_area_id`,
                                null,
                              );
                              if (nextIndex !== fields.length - 1) {
                                setValue(
                                  `assignments.${nextIndex}.drop_area_id`,
                                  null,
                                );
                              }
                            }
                          }

                          if (selectedOption) {
                            GetAllPickupArea(selectedOption.value);
                            GetAllDropArea(selectedOption.value);
                          }

                          setValue(
                            `assignments.${index}.expert_id`,
                            selectedOption,
                          );

                          const area =
                            selectedOption?.data?.Expert_Areas?.[0]?.Area;

                          if (selectedOption && area) {
                            setValue(`assignments.${index}.pickup_area_id`, {
                              value: area.id,
                              name: "pickup_area_id",
                              label: area.name,
                            });
                          } else {
                            setValue(
                              `assignments.${index}.pickup_area_id`,
                              null,
                            );
                          }
                          clearErrors(`assignments.${index}.expert_id`);
                        }}
                      />
                    )}
                  />

                  {errors?.assignments?.[index]?.expert_id && (
                    <span className="text-danger">
                      {errors.assignments[index].expert_id.message}
                    </span>
                  )}
                </Col>

                <Col md={4}>
                  <Form.Label>Pickup Area</Form.Label>

                  <Controller
                    control={control}
                    name={`assignments.${index}.pickup_area_id`}
                    render={({ field }) => (
                      <Select {...field} isDisabled options={pickupAreas} />
                    )}
                  />

                  {errors?.assignments?.[index]?.pickup_area_id && (
                    <span className="text-danger">
                      {errors.assignments[index].pickup_area_id.message}
                    </span>
                  )}
                </Col>

                <Col md={4}>
                  <Form.Label>Drop Area</Form.Label>

                  <Controller
                    control={control}
                    name={`assignments.${index}.drop_area_id`}
                    rules={{
                      required: "Select Drop Area",
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={dropAreas}
                        isDisabled={
                          index === fields.length - 1 ||
                          !assignments[index]?.expert_id
                        }
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption);

                          if (field.value?.value !== selectedOption?.value) {
                            for (
                              let nextIndex = index + 1;
                              nextIndex < fields.length;
                              nextIndex++
                            ) {
                              setValue(
                                `assignments.${nextIndex}.expert_id`,
                                null,
                              );
                              setValue(
                                `assignments.${nextIndex}.pickup_area_id`,
                                null,
                              );
                              if (nextIndex !== fields.length - 1) {
                                setValue(
                                  `assignments.${nextIndex}.drop_area_id`,
                                  null,
                                );
                              }
                            }
                          }

                          // Current row drop area
                          setValue(
                            `assignments.${index}.drop_area_id`,
                            selectedOption,
                          );

                          // Next row pickup area = current row drop area
                          if (fields[index + 1]) {
                            setValue(
                              `assignments.${index + 1}.pickup_area_id`,
                              selectedOption,
                            );

                            if (selectedOption) {
                              GetAllDeliveryBoys(selectedOption, 1);
                            }
                          }
                        }}
                      />
                    )}
                  />

                  {errors?.assignments?.[index]?.drop_area_id && (
                    <span className="text-danger">
                      {errors.assignments[index].drop_area_id.message}
                    </span>
                  )}
                </Col>

                {/* <Col md={2} className="d-flex align-items-end">
                  {index > 0 && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => remove(index)}
                    >
                      Remove
                    </button>
                  )}
                </Col> */}
              </Row>
            ))}

            {/* <div className="mb-3">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() =>
                  append({
                    expert_id: null,
                    pickup_area_id: [],
                  })
                }
              >
                + Add Expert
              </button>
            </div> */}
            {loader ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              dataAssign?.expert_order_status_id ===
                OrderExpertStatus.Pending && (
                <SaveButton
                  name="Assign"
                  handleSubmit={handleSubmit(onSubmit)}
                />
              )
            )}
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default DeliveredUpdateExpertOffCanvance;
